import { Option } from "../projetos/types";

export interface Componente {
  id: number | string | undefined;
  categoria_componentes_id: number | undefined;
  modelo: string | undefined;
  nome: string | undefined;
  nome_comercial: string | undefined;
  descricao: string | undefined;
  descricao_comercial: string | undefined;
  peso: number | string | undefined;
  tempo_garantia: number | string | undefined;
  tempo_garantia_unidade: string | undefined;
  seguimento: string | undefined;
  considerar_calculo: boolean | undefined;
  exibir_listagem: boolean | undefined;
  fabricante: string | undefined;
  comprimento: number | string | undefined;
  largura: number | string | undefined;
  altura: number | string | undefined;
  grupo_mercadoria: string | undefined;
  dados_integracao: any | undefined;
  atributos?: any;
  categoria?: Categoria | {} | undefined;
  mppt?: Mppt[] | undefined | null | [];
  estabelecimentos?: Estabelecimento[] | undefined | null | [];
  inversores_stringbox?: InversorStringBox[] | undefined | null | [];
  uploads?: Upload[] | undefined | null | [];
  modulos?: Modulo[] | undefined | null | [];
  inversores?: Inversor[] | undefined | null | [];
  regioes?: RegiaoComponente[] | undefined | null | [];
  regioes_parametros?: RegiaoParametroComponente[] | undefined | null | [];
  created_at?: string;
  updated_at?: string | null;
  deleted_at?: string | null;
  exibir_popup_parceiro?: boolean;
}

export interface InversorStringBox {
  inversor_id: number,
  created_at?: string;
  updated_at?: string | null;
}

export interface RegiaoParametroComponente {
  regiao_id: number;
  potencia_inicial: number;
  potencia_final: number;
  created_at?: string;
  updated_at?: string | null;
  ["@remove"]?: boolean;
}

export interface RegiaoComponente {
  regiao_id: number;
  created_at?: string | null;
  deleted_at?: string | null;
  ["@remove"]?: boolean;
}

export interface Categoria {
  id: number;
  nome: string;
  grupo: string;
  created_at: Date;
  updated_at: Date;
  deleted_at: null;
}

export interface Mppt {
  id?: number;
  numero: number;
  corrente: number;
  quantidade: number;
  created_at?: string | null;
  deleted_at?: string | null;
}
export interface Upload {
  id?: number;
  tipo: string;
  url: string;
  observacao?: string;
  created_at?: string;
  updated_at?: string | null;
  validade?: string | null;
  ["@remove"]?: boolean;
}

export interface CategoriaComponente {
  id: number;
  nome: string;
  grupo: string;
  descricao: string;
  categoria_componentes_id: number | null;
  ordem_listagem?: number;
  uploads?: Upload[];
  created_at: Date;
  updated_at: null;
  deleted_at: null;
}

export interface GrupoCategoriasComponentes {
  id: number;
  nome: string;
  grupoIds: number[];
}

export interface Modulo {
  id: number;
  modulo_id: number;
  created_at: string | null;
  updated_at: string | null;
  deleted_at: string | null;
}

export interface Inversor {
  id: number;
  inversor_id: number;
  created_at: string | null;
  updated_at: string | null;
  deleted_at: string | null;
}

export interface Estabelecimento {
  estabelecimento_id: number;
  minimo: number;
  considerar_calculo: boolean;
  componente_substituto_id: number | null;
  expedicao: boolean;
  minimo_funil?: number;
  ultima_atualizacao_minimo_funil?: string | null;
  created_at?: string | null;
  updated_at?: string | null;
}

export interface ModuloInversor {
  id: number;
  modulo_id: number;
  inversor_id: number;
  numero_mppt: number;
  numero_string: number;
  quantidade: number;
  quantidade_calculada: number;
  created_at: string;
  updated_at?: string | null | undefined;
  modulo?: Componente;
  inversor?: Componente;
}

export interface GrupoCategoriaComponente {
  value: string;
  label: string;
}

export const gruposCategoriasComponentes: GrupoCategoriaComponente[] = [
  {
    value: "modulos",
    label: "Módulos"
  },
  {
    value: "inversores",
    label: "Inversores"
  },
  {
    value: "acessorios",
    label: "Acessórios"
  },
  {
    value: "itens_estrutura",
    label: "Itens para estrutura"
  },
  {
    value: "verticais",
    label: "Produtos 198",
  }
]

export const ID_MODULO = 1;
export const ID_INVERSOR = 2;
export const ID_ACESSORIO = 11;
export const ID_STRING_BOX = 4;
export const ID_ITENS_ESTRUTURA = 10;
export const ID_PERFIL_ALUMINIO = 19;
export const ID_KIT_ESTRUTURA = 20;
export const ID_EMENDA_PARA_PERFIL = 21;
export const ID_GRAMPO_INTERMEDIARIO = 22;
export const ID_CABO = 23;
export const ID_CONECTOR = 24;
export const ID_KIT_JUNCAO = 25;
export const ID_SUPORTE = 26;
export const ID_CHAPA_METALICA = 27;
export const ID_GRAMPO_FINAL = 28;
export const ID_SUPORTE_SOLO = 29;
export const ID_MICROINVERSOR = 30;
export const ID_CONNECTOR_AC_FEMEA_MICROINVERSOR = 31;
export const ID_TERMINAL_FINAL_FEMEA_MICROINVERSOR = 32;
export const ID_ROTEADOR = 33;
export const ID_GRAMPO_FIXACAO_MICROINVERSOR = 34;
export const ID_MAO_FRANCESA = 35;
export const ID_CONTROLADOR = 100;
export const ID_BATERIA = 110;
export const ID_INVERSOR_ONDA_SENOIDAL = 130;
export const ID_INVERSOR_ONDA_MODIFICADA = 140;
export const ID_INVERSOR_DRIVE_SOLAR = 150;
export const ID_INVERSOR_CARREGADOR = 160;
export const ID_INVERSOR_HIBRIDO = 170;
export const ID_MEDIDOR = 201;
export const ID_TRANSFORMADOR_CORRENTE = 202;
export const ID_MONITORAMENTO = 203;
export const ID_RSD = 204;

export const inversoresMap: {[index: string]: Option<number> } = {
  [ID_INVERSOR]: { text: "Inversor", value: ID_INVERSOR },
  [ID_MICROINVERSOR]: { text: "Microinversor", value: ID_MICROINVERSOR },
  [ID_INVERSOR_ONDA_SENOIDAL]: { text: "Onda Senoidal", value: ID_INVERSOR_ONDA_SENOIDAL },
  [ID_INVERSOR_ONDA_MODIFICADA]: { text: "Onda Modificada", value: ID_INVERSOR_ONDA_MODIFICADA },
  [ID_INVERSOR_DRIVE_SOLAR]: { text: "Drive Solar", value: ID_INVERSOR_DRIVE_SOLAR },
  [ID_INVERSOR_CARREGADOR]: { text: "Carregador", value: ID_INVERSOR_CARREGADOR },
  [ID_INVERSOR_HIBRIDO]: { text: "Inversor Híbrido", value: ID_INVERSOR_HIBRIDO },
}

export const bateriasMap: {[index: string]: Option<number> } = {
  [ID_BATERIA]: { text: "Bateria", value: ID_BATERIA },
}

export const LISTA_INVERSOR_OFFGRID: number[] = [ID_INVERSOR_DRIVE_SOLAR, ID_INVERSOR_ONDA_SENOIDAL, ID_INVERSOR_ONDA_MODIFICADA, ID_INVERSOR_CARREGADOR];
export const LISTA_BATERIAS: number[] = [ID_BATERIA];

export type TEntidadeAtributos = "parametros" | "componentes" | "cupons_desconto" | "funil" | "qitech" | "precos" | "gestao_pedidos" | "estatisticas" | "contas" | "projetos" | "projetos_verticais" | "pedidos" | "dados" | "pagamentos" | "pagamentos_boletos" | "pagamentos_pix" | "pagamentos_cartoes_credito" | "pagamentos_financiamentos" | "pagamentos_financiamentos_direto" | "funil_vertical" | "loja" | "loja_importacao";

export interface IAtributosDom {
    id: string, 
    titulo: string, 
    sufixo?: string, 
    descricao?: string, 
    tipo: number, 
    subtipo: number, 
    entidade_codigo?: string, 
    entidade: TEntidadeAtributos, 
    valor_padrao?: string, 
    valores: any, 
    obrigatorio: boolean, 
    mascara?: string, 
    ordem: number, 
    tamanho: number, 
    precisao: number, 
    multiplo: boolean, 
    aceitar_negativo: boolean, 
    calculado: boolean, 
    deleted_at?: string | Date, 
}

export type TGrupoCategoria = 'modulos' | 'inversores' | 'itens_estrutura' | 'acessorios' | 'baterias' | 'controladores' | 'iluminacao' | 'verticais';
